import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FilesUploadedComponent } from './components/price-from-xl/files-uploaded.component';
import { PriceItemDetailComponent } from './components/price-item-detail/price-item-detail.component';
import { ShipmentPriceItemsComponent } from './components/shipment-price-items/shipment-price-items.component';
import { ServicesComponent } from './components/services/services.component';
import { ServicesTabGroupComponent } from './components/shared/tab-group/services-tab-group.component';
import { UploadXlsComponent } from './components/upload-xls/upload-xls.component';
import { VendorsComponent } from './components/vendors/vendors.component';
import { ShipmentPriceItemResolverService } from './services/resolvers/shipment-price-item-resolver.service';

const routes: Routes = [
    {path: 'services-list', component: ServicesComponent},
    {path: 'prices-from-xl', component: FilesUploadedComponent},
    {path: 'upload-xls', component: UploadXlsComponent},
    {path: 'vendors', component: VendorsComponent},
    {path: 'single-vendors/:id', component: VendorsComponent},
    {
        path: 'single-service/:id',
        component: ServicesTabGroupComponent,
    },
    {path: 'price-list', component: ShipmentPriceItemsComponent},
    { path: 'single-price-items/:id', component: PriceItemDetailComponent, resolve: {data: ShipmentPriceItemResolverService}},
];

@NgModule({
    imports: [ RouterModule.forChild(routes) ],
    exports: [ RouterModule ],
    declarations: [],
})
export class ShipmentPriceRoutingModule {
}
